// extracted by mini-css-extract-plugin
export default {"modal":"ModalDelete_modal__52TBX","description":"ModalDelete_description__SeEWk","title":"ModalDelete_title__lQT-N"};